import { styled } from 'styled-components';

export const StarRatingRow = styled.span`
  display: inline-flex;
  vertical-align: middle;
`;
StarRatingRow.displayName = 'StarRatingRow';

export const StarRatingFullStar = styled.span`
  svg {
    color: ${({ theme }) => theme.colours.messaging.warning.main};
  }
`;
StarRatingFullStar.displayName = 'StarRatingFullStar';

export const StarRatingEmptyStar = styled.span`
  svg {
    color: ${({ theme }) =>
      theme.applyOpacity(theme.colours.graphics.primary.main, 'overlay')};
  }
`;
StarRatingEmptyStar.displayName = 'StarRatingEmptyStar';
